<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
      <audio
        src="./assets/video/sound_Alarm.mp3"
        controls
        id="music"
        style="display: none"
      ></audio>
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
      type: {},
      timer: null,
      timerLogin: null,
    };
  },
  computed: {
    // locale () {
    //   // 原先的en-US改成zh-CN即可
    //   return this.$i18n.getLocaleMessage('zh-CN').antLocale
    // }
  },
  created() {
    var name = 'userInfo' + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = decodeURIComponent(ca[i].trim()); // 解码
      if (c.indexOf(name) == 0) {
        // console.log(JSON.parse(c.substring(name.length, c.length)))
        var param = JSON.parse(c.substring(name.length, c.length));
      }
    }
    this.type = param;
    if (param && this.$route.path != '/login') {
      this.$get(
        '/api/user/' + param.user.id,
        {},
        (res) => {
          if (res.code == 0) {
            this.$store.commit('stateFun', {
              name: 'user_info',
              val: res.data,
            });
          } else {
            // this.$message.error(res.msg);
          }
        },
        (err) => {
          // this.$message.error('服务端发生异常');
        }
      );
    }
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function() {
      history.pushState(null, null, document.URL);
    });
    this.timer = window.setInterval(() => {
      setTimeout(this.getCheck(), 0);
    }, 60000);
    this.timerLogin = window.setInterval(() => {
      setTimeout(this.getCheckLogin(), 0);
    }, 1000);
  },
  methods: {
    getCheck() {
		if (this.$route.path == '/aiShare') {
			return
		}
      var that = this;
      //console.log('登录页判断并删除定时器111111',this.type)
      if (this.$route.path != '/login') {
        //console.log('登录页判断并删除定时器22222',this.$route.path)
        this.$get(
          '/api/check',
          {},
          (res) => {
            if (res.code == 1) {
              this.$router.replace({
                name: 'Login',
              });
            }
          },
          (err) => {
            this.$message.error(err.msg);
          }
        );
      }
    },
    getCheckLogin() {
		if (this.$route.path == '/aiShare') {
			return
		}
      var that = this;

      if (this.$route.path == '/login') {
        let end = setInterval(function() {}, 10000);
        //console.log('登录页判断并删除定时器111111',this.$route.path)
        for (let i = 1; i <= end; i++) {
          if (i != that.timer && i != that.timerLogin) {
            clearInterval(i);
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  position: relative;
}
#app {
  padding: 0 0;
  margin: 0 0;
  width: 100%;
  min-height: 100%;
}
.el-button {
  font-weight: normal !important;
}
// .tbale tr {
//       height: 50px;
// }
// //去除表格底部左右短线
// #app::v-deep .el-table__fixed::before {
//     display: none;
// }
// #app::v-deep .el-table__fixed-right::before {
//     display: none;
// }

// #app::v-deep .el-table::before {
//     display: none;
// }
// .tbale{
//     min-height: 548px;
//     max-height: 567px;
//     overflow: auto;
//     background: #fff;
//     border: 1px solid #EBEEF5;
//     border-bottom: none;
//     border-radius: 4px;
//     margin-top: 10px;
// }
// .tbale .el-table th > .cell{
//   padding-left: 14px;
//   padding-right: 14px;
// }
// .tbale .el-button--mini{
//     padding: 5px 10px;
// }
// .headNav{
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 50px;
// }
// .headNav .search{
//     width: 260px;
// }
// .headNav .search .el-input__icon {
//     position: relative;
//     width: 30px;
//     height: 30px;
//     top: 3px;
//     cursor: pointer;
//     border-radius: 5px;
//     line-height: 32px;
// }

// .headNav .search .el-input__icon:hover {
//     background: #f2f2f2;
// }
// .headNav .el-button--medium{
//   padding: 10px 15px;
// }

//修改动画的大小  给文字加粗效果
.el-loading-spinner {
  font-size: 50px;
  font-weight: bold;
}
//修改文字的大小
.el-loading-mask .el-loading-spinner .el-loading-text {
  font-size: 18px;
}
</style>
